
const Projects = () => {
    return <h1>Projects I am working on</h1>
};

export default Projects;